import { render, staticRenderFns } from "./WhReturnMain.vue?vue&type=template&id=3074ee59"
import script from "./WhReturnMain.vue?vue&type=script&lang=js"
export * from "./WhReturnMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports